import React, { useState } from 'react';
import { Email as EmailIcon } from '@mui/icons-material';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebaseConfig.tsx';
import './AuthPage.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ResetPswd() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    if (!email) {
      toast.error('Please enter your email address');
      setLoading(false);
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      toast.success('Password reset email sent. Please check your inbox.');
    } catch (error) {
      console.error('Error sending password reset email:', error);
      toast.error('If an account with that email exists, a reset link has been sent.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="overlay"></div>
      <div className="content">
        <div className="w-full max-w-md space-y-6 rounded-md text-[#111111]">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold">SARVALOK</h2>
            <br />
            <p className="text-sm text-gray-600">Reset Password</p>
          </div>
          <form className="mt-4 space-y-6" onSubmit={handleForgotPassword}>
            <div className="flex items-center rounded-md border border-gray-300 px-3 py-2">
              <EmailIcon className="mr-2 text-gray-500" />
              <input
                type="email"
                placeholder="Email"
                className="w-full focus:outline-none"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="w-full rounded-md bg-black px-4 py-2 text-white transition-colors hover:bg-gray-800"
            >
              {loading ? <span className="spinner" /> : 'Reset Now'}
            </button>
          </form>
        </div>
        <ToastContainer position="bottom-right" />
      </div>
    </div>
  );
}

export default ResetPswd;
